export const ESTADOS_PARCIALMENTE_ATENDIDOS = {
  SP: true,
  MG: true,
}

export const SP = [
  {
    cidade: "Arujá",
    estato: "SP",
    cep: 7400015,
  },
  {
    cidade: "Barueri",
    estato: "SP",
    cep: 6401000,
  },
  {
    cidade: "Cotia",
    estato: "SP",
    cep: 6700020,
  },
  {
    cidade: "Diadema",
    estato: "SP",
    cep: 9910000,
  },
  {
    cidade: "Guarulhos",
    estato: "SP",
    cep: 7010000,
  },
  {
    cidade: "Itapevi",
    estato: "SP",
    cep: 6652000,
  },
  {
    cidade: "Jandira",
    estato: "SP",
    cep: 6600005,
  },
  {
    cidade: "Mauá",
    estato: "SP",
    cep: 9310000,
  },
  {
    cidade: "Osasco",
    estato: "SP",
    cep: 6010000,
  },
  {
    cidade: "Santo André",
    estato: "SP",
    cep: 9010000,
  },
  {
    cidade: "São Bernardo do Campo",
    estato: "SP",
    cep: 9600004,
  },
  {
    cidade: "São Paulo",
    estato: "SP",
    cep: 1001000,
  }
];

export const MG = [
  { cidade: 'Abadia dos Dourados', estado: 'MG', cep: 38540000 },
  { cidade: 'Araguari', estado: 'MG', cep: 38440001 },
  { cidade: 'Araxá', estado: 'MG', cep: 38180001 },
  { cidade: 'Campina Verde', estado: 'MG', cep: 38270000 },
  { cidade: 'Campo Florido', estado: 'MG', cep: 38130000 },
  { cidade: 'Canápolis', estado: 'MG', cep: 38380000 },
  { cidade: 'Capinópolis', estado: 'MG', cep: 38360000 },
  { cidade: 'Carmo do Paranaíba', estado: 'MG', cep: 38840000 },
  { cidade: 'Cascalho Rico', estado: 'MG', cep: 38460000 },
  { cidade: 'Celso Bueno', estado: 'MG', cep: 38500000 },
  { cidade: 'Comendador Gomes', estado: 'MG', cep: 38250000 },
  { cidade: 'Conceição das Alagoas', estado: 'MG', cep: 38120000 },
  { cidade: 'Conquista', estado: 'MG', cep: 38195000 },
  { cidade: 'Coromandel', estado: 'MG', cep: 38550000 },
  { cidade: 'Estrela do Sul', estado: 'MG', cep: 38525000 },
  { cidade: 'Frutal', estado: 'MG', cep: 38200000 },
  { cidade: 'Ibiá', estado: 'MG', cep: 38950000 },
  { cidade: 'Indianópolis', estado: 'MG', cep: 38490000 },
  { cidade: 'Iraí de Minas', estado: 'MG', cep: 38510000 },
  { cidade: 'Ituiutaba', estado: 'MG', cep: 38300001 },
  { cidade: 'Lagoa Formosa', estado: 'MG', cep: 38720000 },
  { cidade: 'Monte Alegre de Minas', estado: 'MG', cep: 38475000 },
  { cidade: 'Monte Carmelo', estado: 'MG', cep: 38500000 },
  { cidade: 'Nova Ponte', estado: 'MG', cep: 38160000 },
  { cidade: 'Patos de Minas', estado: 'MG', cep: 38700001 },
  { cidade: 'Patrocínio', estado: 'MG', cep: 38740001 },
  { cidade: 'Prata', estado: 'MG', cep: 35765000 },
  { cidade: 'Rio Paranaíba', estado: 'MG', cep: 38810000 },
  { cidade: 'Romaria', estado: 'MG', cep: 38520000 },
  { cidade: 'Sacramento', estado: 'MG', cep: 35342000 },
  { cidade: 'Santa Juliana', estado: 'MG', cep: 38175000 },
  { cidade: 'Santa Vitória', estado: 'MG', cep: 38320000 },
  { cidade: 'Tapuirama', estado: 'MG', cep: 38439600 },
  { cidade: 'Tupaciguara', estado: 'MG', cep: 38480000 },
  { cidade: 'Uberaba', estado: 'MG', cep: 38001959 },
  { cidade: 'Uberlândia', estado: 'MG', cep: 38400010 }
];

const TODAS_CIDADES = [...SP, ...MG]

export function isStatePartiallyAttended(state) {
  return ESTADOS_PARCIALMENTE_ATENDIDOS[state];
}

export function getCidadeDestinoPorEstado(data){
  const cidadeDestino = data['cidadeDestinoSP'] || data['cidadeDestinoMG'];

  if (cidadeDestino) {
    const foundCity = TODAS_CIDADES.filter(cidade => {
      return cidade.cidade === cidadeDestino
    })[0]

    if (!foundCity) {
      console.error("Cidade não encontrada no Banco de Dados de cidades.");
      return undefined;
    }

    return foundCity;
  }
}
